import {watchLandingBannerClick} from '../api';

async function onBannerClick(eventId, bannerId)
{
	const formData = new FormData();
	formData.append('eventId', eventId);
	formData.append('bannerId', bannerId);

	return watchLandingBannerClick(formData);
}

export default onBannerClick;
